<template>
  <v-card class="pa-4">
    <v-flex xs12 pb-3 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-flex xs12 pb-3 v-if="success">
      <v-alert :value="true" type="success">{{success}}</v-alert>
    </v-flex>
    <v-form v-model="isValid">
      <v-text-field
        :label="$lang.labels.password"
        :rules="[() => newPassword.length > 0 || `${$lang.errors.missingPass}`]"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        :type="show ? 'text' : 'password'"
        v-model="newPassword"
        @click:append="show = !show"
      />
      <v-layout
        justify-space-between
        row>
        <v-btn
          class="mx-0"
          :disabled="updating"
          @click="$emit('close')">
          {{ $lang.actions.close }}
        </v-btn>
        <v-btn
          :disabled="!isValid || updating"
          :loading="updating"
          class="mx-0 primary"
          @click="updatePassApi()">
          {{ $lang.actions.submit }}
        </v-btn>
      </v-layout>
    </v-form>
  </v-card>
</template>

<script>
export default {
  props: ['isSms', 'isTerminal'],
  data: () => ({
    newPassword: '',
    isValid: false,
    updating: false,
    success: '',
    err: '',
    show: false,
  }),
  methods: {
    updatePassApi() {
      this.updating = true;
      let url = 'webshopresource/updatepaymentgatewaypassword';
      let obj = { password: this.newPassword };
      if (this.isSms) url = 'webshopresource/updatesmspassword';
      if (this.isTerminal) {
        url = 'paymentterminal/updatepassword';
        obj = {
          password: this.newPassword,
          companyId: localStorage.selectedTerminal,
        }
      }
      this.$http.post(`${url}/${this.$route.params.id}`, obj)
        .then((res) => {
          if (res === null) return;
          if (res.body.status === 'Success') {
            this.success = 'Password updated successfully.';
            this.updating = false;
            setTimeout(() => {
              this.success = '';
              this.$emit('close');
            }, 4000);
            return;
          }
          this.updating = false;
          this.err = res.body.statusText;
        })
        .catch((err) => {
          this.updating = false;
          this.err = err.body.statusText || err.body.message;
        });
    },
  },
}
</script>



// WEBPACK FOOTER //
// ChangePassword.vue?3e4cc659